const OFFLINE_DISABLED_TPV_PERMISSIONS = new Set([
  'carta-basica',
  'dashboard',
  'inteligencia-artificial',
  'fidelizacion',
  'control-horario',
  'reservas',
  'caja',
  'personal',
  'facturas',
  'clientes-habituales',
]);

const OFFLINE_DISABLED_SECTION_LABELS = {
  'carta-basica': 'Activar platos',
  dashboard: 'Dashboard',
  'inteligencia-artificial': 'Inteligencia artificial',
  fidelizacion: 'Fidelizacion',
  'control-horario': 'Control horario',
  reservas: 'Reservas',
  caja: 'Caja',
  personal: 'Personal',
  facturas: 'Facturas',
  'clientes-habituales': 'Clientes habituales',
};

export function isTpvPermissionDisabledOffline(permission) {
  return OFFLINE_DISABLED_TPV_PERMISSIONS.has(permission);
}

export function getOfflineDisabledSectionTitle(permission) {
  return OFFLINE_DISABLED_SECTION_LABELS[permission] || 'Seccion no disponible';
}

export { OFFLINE_DISABLED_TPV_PERMISSIONS };
